import '@/scss/app.scss';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

//vue carousel
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

//vue cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

//import { isMobile } from 'mobile-device-detect';

Vue.config.productionTip = false

new Vue({
	//mixins: [mixinDetictingMobile],
	router,
	store,
	render: h => h(App),
}).$mount('#app')
